import React from 'react';
import {useSelector} from 'react-redux';
import CSSTransition from "react-transition-group/cjs/CSSTransition";
import Overlay from "./components/Overlay";
import Content from "./components/Content";
import Spinner from "./components/Spinner";
import Svg from "./components/Svg";
import Circle from "./components/Circle";
import loadingTransition from './cssTransition.module.css';


const LoadingOverlays = () => {

    const loadingOverlays = useSelector(state => state.loadingOverlays);


    return (
        <CSSTransition classNames={loadingTransition}
                       mountOnEnter
                       unmountOnExit
                       appear
                       in={loadingOverlays.isActive}
                       timeout={1000}>
            <Overlay>
                <Content>
                    <Spinner>
                        <Svg>
                            <Circle/>
                        </Svg>
                    </Spinner>
                    <div>
                        {loadingOverlays.text}
                    </div>
                </Content>
            </Overlay>
        </CSSTransition>
    )
}


export default LoadingOverlays;
